import { all, fork } from "redux-saga/effects";

import LayoutSaga from "./layout/saga";
//import calendarSaga from "./calendar/saga";
import accountSaga from "./auth/register/saga";
import authSaga from "./auth/login/saga";
//import { watchGetCompany } from "./companyStore/sagas";
import procedureSaga from "./modifJson/procedureSaga"; // Importez votre nouvelle saga

export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    //fork(calendarSaga),
    fork(accountSaga),
    fork(authSaga),
    //fork(watchGetCompany),
    fork(procedureSaga), // Lancez votre nouvelle saga
  ]);
}



//Creators : Florian Cohen-Joly / Thomas Castanier @3DDGAMES -- Under license